export default __webpack_public_path__ + "static/media/黃瀚萱.55ac65c1.jpg";